exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-enter-active[data-v-299d62fa],.list-leave-active[data-v-299d62fa]{transition:all .3s}.list-enter[data-v-299d62fa],.list-leave-to[data-v-299d62fa]{opacity:0;transform:translateY(-30px)}", ""]);

// exports
